import { Grid } from '@mui/material'
import { Child } from '../../../../containers/common/child'
import { GItem } from '../grids'
import { UnitTitle } from './unitTitle'
import { getYesNoText } from '../../../../containers/common/category'
import { OperationId } from '../../../../containers/common/constant/operationLog'
import { GetCategoryMstDto } from '../../../../dataAccess/webApi/dto/categoryMstDto'
import { executeGetChildrenHospitalAdmission } from '../../../../dataAccess/webApi/dao/childrenHospitalAdmissionDao'
import { GetChildrenHospitalAdmissionDto } from '../../../../dataAccess/webApi/dto/childrenHospitalAdmissionDto'
import { memberModifyChildHospitalAdmissionUrl } from '../../../../containers/common/constant/appUrl'

const HOSPITAL_ADMISSION = 'hospitalAdmission'
const SUB_CATEGORIES = ['hospitalAdmission.admissionAge', 'hospitalAdmission.reason']
export const CATEGORY_NAMES = [HOSPITAL_ADMISSION, ...SUB_CATEGORIES]

interface ChildHospitalAdmissionUnitProps {
  child?: Child
  sectionLabel: string
  categoryMst?: GetCategoryMstDto[]
  hideLink?: boolean  
}

export const ChildHospitalAdmissionUnit = (props: ChildHospitalAdmissionUnitProps) => {
  const { categoryMst, child, sectionLabel } = props
  const MAX_RECORD = 2

  if (child == null || categoryMst == null || categoryMst.length === 0) return null
  
  const hospitalAdmissionCategory = categoryMst.find((value) => value.category === HOSPITAL_ADMISSION)
  const subCategories = categoryMst.filter((mst) => SUB_CATEGORIES.includes(mst.category))
 
  if (!hospitalAdmissionCategory || subCategories.length === 0) return null
  
  const subCategoryMap: {[key:string]: GetCategoryMstDto} = {}
  subCategories?.forEach(e => subCategoryMap[e.category.substring(HOSPITAL_ADMISSION.length + 1)] = e)
  
  const recordCnt = child.hospitalAdmission?.length ?? 0
  return (
    <>
      <UnitTitle title={sectionLabel} linkTo={memberModifyChildHospitalAdmissionUrl.url(child.childId)} operationLog={{ operationId: OperationId.OP_00000183 }} hideLink={props.hideLink} />
      <Grid container>
        { recordCnt === 0 ? (
          <GItem xs={12}>{getYesNoText(hospitalAdmissionCategory, undefined)}</GItem>
        ) : (
          child.hospitalAdmission?.slice(0, MAX_RECORD).map((hospitalAdmission, i) => {
            return (<DataRow
              key={`hospitalAdmission${i}`}
              categoryMap={subCategoryMap}
              hospitalAdmission={hospitalAdmission}
            />)
          })
        )}
        { recordCnt > MAX_RECORD && <GItem xs={12}>...</GItem> }
      </Grid>
    </>
  )
}

interface DataRowProps {
  categoryMap: {[key:string]: GetCategoryMstDto}
  hospitalAdmission: GetChildrenHospitalAdmissionDto
}

const DataRow = ({ categoryMap, hospitalAdmission }: DataRowProps) => {
  return (
    <>
      {categoryMap.admissionAge && hospitalAdmission.admissionAge != null && hospitalAdmission.admissionMonth != null && 
        <GItem xs={2} md={1}>{`${hospitalAdmission.admissionAge}歳${hospitalAdmission.admissionMonth}ヶ月`}</GItem>
      }
      {categoryMap.reason && <GItem xs={10} md={11}>{hospitalAdmission.reason}</GItem>}
    </>
  )
}

/**
 * 入院情報を取得
 */
export const resetHospitalAdmission = async (id: string, facilityId: string, baseObj: any) => {
  const resp = await executeGetChildrenHospitalAdmission(id, facilityId)
  baseObj.hospitalAdmission = resp.result
}